<template>
  <div v-if="routerName.includes($route.name)">
    <div class="search-wrap">
      <el-input
        class="search-input"
        placeholder="搜索课程"
        size="medium"
        v-model.trim="keyword"
        @keyup.enter.native="onSearch"
        maxlength="100"
      >
        <i
          slot="prefix"
          class="el-input__icon el-icon-search"
          @click.stop="onSearch"
        ></i>
      </el-input>
    </div>
    <div class="seize-seat-ele"></div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  data: function () {
    return {
      keyword: "",
      routerName: ["Home", "CourseList"],
    };
  },
  methods: {
    onSearch() {
      if (this.keyword) {
        if (this.$route.name === "CourseList") {
          EventBus.$emit("keyword", this.keyword);
        } else if (this.keyword) {
          this.$router.push(`/course-list?keyword=${this.keyword}`);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.seize-seat-ele {
  height: 1.33rem;
}
.search-wrap {
  position: fixed;
  width: 100%;
  height: 1.33rem;
  top: 0;
  z-index: 1001;
  padding: 0 0.32rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  ::v-deep .search-input input {
    background: #f5f5f6;
    border-radius: 0.21rem;
  }
  ::v-deep .el-input__inner {
    border: none;
  }
  ::v-deep .el-input__inner::placeholder {
    color: #9e9f9c;
  }
}
</style>
